export default "__VITE_ASSET__BAG9TGhC__"